import type { InjectionKey } from 'vue'

export type PauseClickOutsideFn = (callback: () => void | Promise<void>) => Promise<void>

export const PAUSE_CLICK_OUTSIDE: InjectionKey<PauseClickOutsideFn> = Symbol('pause-click-outside')
